import Vue from 'vue';
import { RECAPTCHA_SITE_KEY } from '@shared/helpers/env';
import i18n from '@app/plugins/i18n';

export function captcha(action, callback) {
  window.grecaptcha.ready(() => {
    try {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then((token) => {
          callback(token);
        })
        .catch(() => {
          Vue.noty.error(i18n.t('core.errors.recaptcha'));
        });
    } catch {
      Vue.noty.error(i18n.t('core.errors.recaptcha'));
    }
  });
}
